import { UseQueryOptions } from 'react-query';
import { useGetEventQuery } from './index';

/** Gets a single event or recurrence instance if one is provided */
export const useGetEvent = (
  id: string | undefined,
  options?: UseQueryOptions
) => {
  const { data: item, ...result } = useGetEventQuery(id, options);

  return {
    item,
    ...result,
  };
};
